const home = [
  {
    path: '/homePage',
    name: 'homePage',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "home" */ '@/views/home/homePage'),
    meta: {
      name: '知产交易 · 全网专利交易查询',
      breadCrumbName: '专利交易中心'
    }
  },
  {
    path: '/patentList',
    name: 'patentList',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "home" */ '@/views/home/patentList'),
    meta: {
      name: '知产交易 · 全网专利交易查询',
      breadCrumbName: '专利交易中心'
    }
  },
  {
    path: '/nineGridShare',
    name: 'nineGridShare',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "home" */ '@/views/home/nineGridShare'),
    meta: {
      name: '知产交易 · 制作图片',
      breadCrumbName: '制作图片'
    }
  },
  
];

export default home
